export default __webpack_public_path__ + "static/portfolio-banner-default-ad9de08d71f302bfbc0c916ff4062d06.jpg";